import { apiRequest } from './index';

export const generateEmployeePayrollRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/payroll/employee',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}
